export const ExpenseTypeIds = {
    RENT_EXPENSE_ID: '64d8bb74-0cd5-43c6-b5f9-bf770ad7e05b',
    FOOD_EXPENSE_ID: '5a879191-f0ff-f3dc-dc1a-326d26a21daf',
    LEARNING_MATERIALS_ID: '21739cd5-de35-3579-c30c-bd2337770c3c',
    MAINTENANCE_ID: '4e2fd7d4-5b8e-b020-a8e0-eb559832ba02',
    OTHER_EXPENSE_ID: '9ca053ea-9fa5-c3f9-d72f-2ac73289820b',
    UTILITIES_EXPENSE_ID: 'cbd9eb92-70a2-6fd2-caca-f6b137842e24',
    SALARY_EXPENSE_ID: '8c70d480-7579-477e-ec7e-db3515345840',
    PRINCIPAL_SALARY_EXPENSE_ID: '973b94c9-3f95-4e35-8cbc-756f63bdab43',
};
//# sourceMappingURL=statements-expenses-types.dto.js.map